import Vue from 'vue/dist/vue.esm'

Vue.component(
  "rfc-search-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/RfcSearch")
)
